import { api } from '../../_generated/api/assets-api.generated';

export const customFieldsApi = api.enhanceEndpoints({
  addTagTypes: ['CustomField'],
  endpoints: {
    ReadCustomFields: {
      providesTags: (result) => [
        { type: 'CustomField' as const, id: 'LIST' },
        ...(result?.readCustomFields ?? []).map((customField) => ({
          type: 'CustomField' as const,
          id: customField.fieldId,
        })),
      ],
    },
    ReadCustomFieldsForAssetType: {
      providesTags: (result, _, arg) => [
        { type: 'CustomField' as const, id: `ASSET_TYPE:${arg.assetType}` },
        ...(result?.readCustomFieldsForAssetType ?? []).map((customField) => ({
          type: 'CustomField' as const,
          id: customField.fieldId,
        })),
      ],
    },
    CreateCustomField: {
      invalidatesTags: [{ type: 'CustomField' as const, id: 'LIST' }],
    },
    UpdateCustomField: {
      invalidatesTags: (_, __, arg) => [
        { type: 'CustomField' as const, id: arg.fieldId },
        { type: 'CustomField' as const, id: 'LIST' },
      ],
    },
    ActivateCustomField: {
      invalidatesTags: (_, __, arg) => [
        { type: 'CustomField' as const, id: arg.fieldId },
        { type: 'CustomField' as const, id: 'LIST' },
        'CustomField' as const,
      ],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;

        dispatch(
          customFieldsApi.util.updateQueryData(
            'ReadCustomFields',
            undefined,
            (draft) => {
              const field = draft.readCustomFields.find(
                (customField) =>
                  customField.fieldId === data.activateCustomField.fieldId,
              );

              if (field) {
                field.status = data.activateCustomField.status;
              }
            },
          ),
        );
      },
    },
    DeactivateCustomField: {
      invalidatesTags: (_, __, arg) => [
        { type: 'CustomField' as const, id: arg.fieldId },
        { type: 'CustomField' as const, id: 'LIST' },
        'CustomField' as const,
      ],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;

        dispatch(
          customFieldsApi.util.updateQueryData(
            'ReadCustomFields',
            undefined,
            (draft) => {
              const field = draft.readCustomFields.find(
                (customField) =>
                  customField.fieldId === data.deactivateCustomField.fieldId,
              );

              if (field) {
                field.status = data.deactivateCustomField.status;
              }
            },
          ),
        );
      },
    },
    LinkCustomField: {
      invalidatesTags: (_, __, arg) => [
        {
          type: 'CustomField' as const,
          id: `ASSET_TYPE:${arg.linkage.assetType}`,
        },
        { type: 'CustomField' as const, id: 'LIST' },
      ],
    },
    UnlinkCustomField: {
      invalidatesTags: (_, __, arg) => [
        {
          type: 'CustomField' as const,
          id: `ASSET_TYPE:${arg.linkage.assetType}`,
        },
        { type: 'CustomField' as const, id: 'LIST' },
      ],
    },
  },
});

export const {
  useReadCustomFieldsQuery,
  useReadCustomFieldsForAssetTypeQuery,
  useCreateCustomFieldMutation,
  useUpdateCustomFieldMutation,
  useActivateCustomFieldMutation,
  useDeactivateCustomFieldMutation,
  useLinkCustomFieldMutation,
  useUnlinkCustomFieldMutation,
  useReadCustomFieldSupportedAssetTypesQuery,
  useLazyReadCustomFieldsForAssetTypeQuery,
} = customFieldsApi;
